import script from "./dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./dashboard.vue?vue&type=script&setup=true&lang=js"

import "./dashboard.vue?vue&type=style&index=0&id=2be7cca8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2be7cca8"]])

export default __exports__